export default {
  headerMenu: {
    home: '首页',
    product: '产品与应用',
    resource: '模型与数据资源',
    model: '共享模型',
    database: '共享数据库',
    community: '研究者社区',
    publish: '论文与案例',
    subscribe: '订阅',
    about: '关于',
  },
  footerMenu: {
    company: '公司',
    column: '关于一湾',
    column1: '加入我们',
    column2: '合作伙伴',
    product1: '产品',
    column3: '2D-AI 动物行为分析系统',
    column4: '3D-AI 动物行为分析系统',
    column5: '3D-AI 动物运动功能分析系统',
    community: '社区',
    column6: '动物眼动追踪系统',
    column7: '动物 VR 虚拟现实系统',
    column8: '动物视觉刺激系统',
    column9: 'AI 动物面部分析系统',
    columnPig: '3D-AI 猪行为分析系统',
    law: '法律',
    column10: '隐私政策',
    column11: '条款和条件',
    column12: '退款服务',
    contact: '如果您在使用过程中遇到任何问题，可联系',
    column14: '020-89114381',
    column15: '©2025 广东一湾生命科技有限公司',
    column16: '粤ICP备15067788号',
    column17: '粤公网安备 44010602005675号',
    column18: '营业执照',
    emailPath1: 'info@bayonesci.com',
    emailPath2: 'support@bayonesci.com',
    login: '注册/登陆探索更多功能',
    loginText: '探索更多功能',
    social: '关注社交媒体账号',
    call: '或致电',
    phoneNumber: '020-89114381',
  },
  home:{
    loadingText:'加载中...',
    databaseOverview:'数据库总览',
    behaviorSubtype:'行为亚型',
    speciesTotal:'品系总数',
    actionSamples:'动作样本',
    filterSystem:'筛选体系',
    enterPhenomicsAtlasDetail:'进入 PHENOMICSATLAS 详情页面',
    multiSpeciesFeatureComparison:'多疾病特征对比',
    speedDistribution:'运动速度分布 (含全疾病基准)mm/s',
    bodySizeComparison:'体型参数对比 (归一化/Base对比)',
    platformDescription:'多物种行为表型组学大数据平台 · 从数据到洞察，共建神经行为与表型关联'
  },
  data:{
    noData:'暂无数据',
    selectSample:'请从左侧选择样本',
    allSelect:'全选',
    confirmFilters:'确定筛选',
    selectedComparison:'对比已选 ({count})'
  },
  groupComparisonPanel:{
    title:'多维行为与运动学联合分析平台',
    behaviorActionFraction:'20 类行为动作占比降维 (UMAP 3D)',
    dragRotate:'支持鼠标拖拽旋转',
    coreActionDuration:'20 类核心动作分组时长对比 (FDR &lt; 0.05)',
    kmeansCluster:'K-means 降维聚类散点图',
    envelopeSurface:'包络面标示类簇',
    confusionMatrix:'聚类混淆矩阵 (Confusion Matrix)',
    behaviorRatioCorrelation:'样本间行为占比相关性',
    bottomColorBand:'侧底色带指示分组',
    allSamplesBehaviorFraction:'所有样本 20 类动作占比指纹图谱 (Fraction Heatmap)',
    bottomColor:'底部色带指示样本分组与序列',
    ethogram:'Ethogram (全动作多样本行为时序发生图)',
    filterAction:'点击上方图例过滤特定动作',
    BodyGrooming:'rearing 发生概率时序分布',
    confidenceInterval:'阴影区域为 95% 置信区间',
    kinematicParameterComparison:'39 个运动学参数组间宏观对比分析',
    bottomSlider:'支持底部滑块缩放以查看细分特征',
    pca3d:'39 参数特征空间 (PCA 3D)',
    kmeansConfusionMatrix:'K-means 聚类混淆矩阵',
    radarKinematic:'身体各关节点运动能量雷达分布',
    kineProbHeatmap:'Kine Probability Heatmap (核心指标分布密度)',
    microProbDistribution:'各分组在速度、运动强度、位移、身体姿态上的极微观概率分布（每一行为一个样本）'
  }
}
